<template>
  <CCardHeader> {{ title }} - {{ rows }} rows</CCardHeader>
</template>

<script>
export default {
  name: "PageTitle",
  props: ["title", "rows"],
  data() {
    return {
      
    };
  },
};
</script>
